<template>
  <baseEdit />
</template>

<script>
  import baseEdit from './baseEdit';

  export default {
    name: 'editReceipt',
    components: {
      baseEdit,
    },
  };
</script>
